module.exports = __webpack_public_path__ + "img/smart-media.f88e4a89.png";